export default "__VITE_ASSET__EnxEFq0E__"